<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          List of All Posts {{ Name }}
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addNewPost">Add New Post</vs-button>
        </h3>
        <p class="card-subtitle">List of Posts that will be viewed on User's Phone.</p>
        <vs-row>
          <div style="display: flex; align-items: center; gap: 0.5rem">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData">
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>

            <vs-select :color="colorx" label="Sorting Type" v-model="search.sort" @change="searchData">
              <vs-select-item value text="Select Sorting" disabled />
              <vs-select-item value="ASC" text="Ascending" />
              <vs-select-item value="DESC" text="Descending" />
            </vs-select>

            <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData">
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>

            <vs-select :color="colorx" label="Page Limit" v-model="limit" @change="searchData">
              <vs-select-item value="25" text="25" />
              <vs-select-item value="50" text="50" />
              <vs-select-item value="100" text="100" />
            </vs-select>

            <!-- <vs-button color="primary" type="filled" class="searchBtn" @click="searchData()"
              icon="search">Search</vs-button> -->
            <vs-button
              color="success"
              type="filled"
              class="searchBtn"
              icon="sort"
              v-if="this.$data.routeCategoryGuid !== undefined"
              @click="sortPositions()"
              style="width: 12%"
              >Sort</vs-button
            >
            <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()" style="width: 12%">Reset</vs-button>
          </div>
        </vs-row>
        <br />
        <table class="table" style="text-align: center">
          <tr>
            <th>#</th>
            <th></th>
            <th>Name</th>
            <th>Description</th>
            <th>Category</th>
            <th @click="sortBy('position')" style="cursor: pointer">
              Position
              <span v-if="sortByField === 'position'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th>Language</th>
            <th @click="sortBy('status')" style="cursor: pointer">
              Status
              <span v-if="sortByField === 'status'">{{ sortDirection === "asc" ? "▲" : "▼" }}</span>
            </th>
            <th @click="sortBy('totalShares')" style="cursor: pointer">
              Shares
              <span v-if="sortByField === 'totalShares'">{{ sortDirection === "desc" ? "▼" : "▲" }}</span>
            </th>
            <th>Tags</th>
            <th></th>
            <th>Publish Date</th>
          </tr>
          <tr v-for="(item, index) in all" :key="item._id">
            <td class="td">{{ index + 1 + (currentPage - 1) * limit }}</td>
            <td class="td">
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td class="td">{{ item.name }}</td>
            <td class="td">
              <span class="material-icons eye" @click="viewDescription(item)">remove_red_eye</span>
            </td>
            <td class="td">{{ item.categoryObject.name }}</td>
            <td class="td">
              <!-- add up and down arrows from react-icons -->
              <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 0.5rem">
                <vs-button
                  icon="arrow_upward"
                  size="small"
                  v-if="routeCategoryGuid !== undefined"
                  @click="updatePosition(item, search.sort === 'ASC' ? 'up' : 'down')"
                ></vs-button>
                {{ item.position }}
                <vs-button
                  icon="arrow_downward"
                  size="small"
                  v-if="routeCategoryGuid !== undefined"
                  @click="updatePosition(item, search.sort === 'ASC' ? 'down' : 'up')"
                ></vs-button>
              </div>
            </td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div
                    class="progress-bar p-2"
                    :style="{
                      color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                      backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                      width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                    }"
                  >
                    <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <td class="td">
              <vs-button style="width: auto" color="primary" type="filled" class="searchBtn" icon="">facebook {{ item.count.facebook }}</vs-button>
              <vs-button style="width: auto" color="success" type="filled" class="searchBtn">whatsapp {{ item.count.whatsapp }}</vs-button>
              <vs-button style="width: auto" color="#e94859" type="filled" class="searchBtn">instagram {{ item.count.instagram }}</vs-button>
              <vs-button style="width: auto" color="warning" type="filled" class="searchBtn">Total {{ item.totalShares }}</vs-button>
            </td>
            <td class="td">
              <vs-chip style="font-size: 9px" v-for="(i, index) in item.tags" :key="index" color="dark">{{ i }}</vs-chip>
            </td>
            <td class="td">
              <vs-dropdown>
                <vs-icon class icon="more_vert"></vs-icon>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editingItem(item, 'edit')"> <vs-icon class="align-right" icon="create"></vs-icon>Edit </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      deletePostPopup = true;
                      itemToDelete = item;
                    "
                  >
                    <vs-icon class icon="delete_sweep"></vs-icon>Delete
                  </vs-dropdown-item>
                  <!-- <vs-dropdown-item @click="editingItem(item, 'clone')">
                    <vs-icon class="align-right" icon="content_copy"></vs-icon>Duplicate
                  </vs-dropdown-item> -->
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
            <td class="td">
              {{ formatDate(item.createdAt) }}
            </td>
          </tr>
        </table>
        <!-- pagination -->
        <vs-pagination v-model="currentPage" :total="totalPages" :limit="limit" @change="searchData" class="my-4" />

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Post' : clone ? 'Duplicate Post' : 'Edit Post'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select
                :color="colorx"
                label="Language Filter"
                @change="fileterusingLanguage($event, post)"
                v-model="post.language"
                icon="arrow_downward"
                :disabled="isNew"
              >
                <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in postLanguages" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select :color="colorx" label="Post Category" v-model="category" icon="arrow_downward">
                <vs-select-item value text="Choose Category" disabled />
                <vs-select-item :value="item._id" :text="item.name" v-for="(item, index) in postCategories" :key="index" />
              </vs-select>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt20">
              <vs-input label="Post Name (Keep it Simple and short)" v-model="post.name" />
            </vs-col>
            <!-- <vs-col vs-lg="12" vs-xs="12">
              <vs-input type="number" label="Post Position (Try to assign different position)"
                v-model="post.position" />
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" v-if="!isNew">
              <p class="mt-2" style="font-size: 0.85rem">Current Position: {{ post.position }}</p>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" v-if="isNew">
              <p class="mt-2" style="font-size: 0.85rem">Position:</p>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-2">
              <vs-checkbox v-model="post.moveTop" @change="post.moveBottom = false">Move to Top</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-2">
              <vs-checkbox v-model="post.moveBottom" @change="post.moveTop = false">Move to Bottom</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Post Tags</label>
              <Multiselect placeholder="Select Tags" v-model="post.tags" :options="tags" :track-by="tags.name" :multiple="true"></Multiselect>
            </vs-col>
            <br />
            <div style="display: flex; width: 100%; align-items: center; justify-content: center; padding-top: 1rem; z-index: 0">
              <vs-checkbox v-model="post.status">Status (Active / Inactive)</vs-checkbox>
            </div>
            <div class="mt-4" style="padding-left: 1rem; padding-right: 1rem" v-if="isNew">
              <p>Choose Languages to Translate</p>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem">
                <vs-checkbox v-model="selectAll" @change="toggleSelectAll">All</vs-checkbox>
                <div v-for="lang in languages" :key="lang.culture">
                  <vs-checkbox
                    :value="post.languagesToTranslate.includes(lang.culture)"
                    :disabled="lang.culture === 'EN'"
                    @change="toggleLanguage(lang.culture)"
                  >
                    {{ lang.culture }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
            <div
              class="mt-4"
              style="padding-left: 1rem; padding-right: 1rem"
              v-if="!isNew && post.language == 'EN' && post.missingLanguages.length > 0"
            >
              <div class="mb-4" style="display: flex; align-items: center">
                <vs-checkbox v-model="post.translateMissing">Add missing translations</vs-checkbox>
              </div>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem" v-if="post.translateMissing">
                <vs-checkbox v-model="selectAllEdit" @change="toggleSelectAllEdit">All</vs-checkbox>
                <div v-for="lang in post.missingLanguages" :key="lang">
                  <vs-checkbox
                    :value="post.languagesToTranslate.includes(lang) && lang !== 'EN'"
                    :disabled="lang.culture === 'EN'"
                    @change="toggleLanguage(lang)"
                  >
                    {{ lang }}
                  </vs-checkbox>
                </div>
              </div>
            </div>

            <!-- <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <uploader label="Post Image" v-model="post.image" :file="post.image" /> 
            </vs-col> -->
            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Post Image</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage()"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Post Description</label>
              <vs-textarea v-model="post.description" />
              <!-- <vue-editor v-model="post.description"></vue-editor> -->
            </vs-col>
            <vs-col vs-lg="9" vs-xs="12" class="mt20">
              <vs-button icon="save" v-if="isNew" @click="post.languagesToTranslate.length > 1 ? createAndTranslate() : btnAddPost()">
                {{ post.languagesToTranslate.length > 1 ? "Save and Translate" : "Save" }}
              </vs-button>
              <vs-button icon="save" v-if="!isNew && !showLoader && !clone" @click="btnAddPost()">Save</vs-button>
              <vs-button class="ml-3" v-if="!isNew && !showLoader && !clone && post.language === 'EN'" icon="save" @click="updateAndTranslate"
                >Update all</vs-button
              >
              <vs-checkbox class="mt-2" v-model="post.translate" v-if="!isNew && !clone && post.language === 'EN'"
                >Update existing translations</vs-checkbox
              >
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup title="Delete Post" :active.sync="deletePostPopup">
          <p>Are you sure you want to delete Post?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deletePost">Delete Post</vs-button>
            <vs-button icon="clear" @click="deletePostPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>

        <vs-popup title="View Details" :active.sync="viewDetails">
          <div>{{ details }}</div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import Vue from "vue";
import { API } from "@/common/constants";
// import { VueEditor } from "vue2-editor";
import Multiselect from "vue-multiselect";
import VPopover from "vue-js-popover";
import moment from "moment";

Vue.use(VPopover, { tooltip: true });

export default {
  name: "Post",
  components: {
    // uploader,
    // VueEditor,
    Multiselect,
  },
  data: () => ({
    title: "Post",
    colorx: "#0D2144",
    defaultalert: false,
    deletePostPopup: false,
    viewDetails: false,
    displayImage: "",
    sortByField: "",
    sortDirection: "asc",
    fileName: "",
    Name: "",
    details: "",
    isNew: true,
    clone: false,
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
    },
    category: "",
    selectAll: false,
    selectAllEdit: false,
    limit: 25,
    currentPage: 1,
    totalPages: 0,
    post: {
      missingLanguages: [],
      languagesToTranslate: ["EN"],
      name: "",
      description: "",
      status: true,
      language: "",
      position: "",
      image: "",
      count: {
        categoryObject: {},
        facebook: 0,
        whatsapp: 0,
        instagram: 0,
        totalShares: 0,
      },
      tags: [],
      moveTop: false,
      moveBottom: false,
      translate: false,
    },
    tags: [],
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
    languages: [],
    postLanguage: "",
    postLanguages: [],
    postCategories: [],
    routeCategoryGuid: "",
    routeCatLanguage: "",
    routeTagLanguage: "",
    routeCategoryName: "",
    routeTagName: "",
    englishData: {},
    enCat: "",
    cat2: "",
    showLoader: false,
  }),
  computed: {
    sortedData() {
      return this.all.sort((a, b) => {
        if (this.sortDirection === "asc") {
          return a[this.sortByField] > b[this.sortByField] ? 1 : -1;
        } else {
          return a[this.sortByField] < b[this.sortByField] ? 1 : -1;
        }
      });
    },
  },
  watch: {
    "search.language": function (newLang, oldLang) {
      if (newLang !== oldLang) {
        this.currentPage = 1;
      }
    },
    "search.sort": function (newSort, oldSort) {
      if (newSort !== oldSort) {
        this.currentPage = 1;
      }
    },
    "search.status": function (newStatus, oldStatus) {
      if (newStatus !== oldStatus) {
        this.currentPage = 1;
      }
    },
    limit: function (newLimit, oldLimit) {
      if (newLimit !== oldLimit) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    toggleSelectAll() {
      if (this.selectAll) {
        this.post.languagesToTranslate = this.languages.map((lang) => lang.culture);
      } else {
        this.post.languagesToTranslate = ["EN"];
      }
    },

    toggleSelectAllEdit() {
      if (this.selectAllEdit) {
        this.post.languagesToTranslate = this.post.missingLanguages;
      } else {
        this.post.languagesToTranslate = ["EN"];
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    toggleLanguage(culture) {
      const selectedLanguages = this.post.languagesToTranslate;

      if (selectedLanguages.includes(culture)) {
        this.post.languagesToTranslate = selectedLanguages.filter((lang) => lang !== culture);
      } else {
        this.post.languagesToTranslate = [...selectedLanguages, culture];
      }

      const allLanguagesSelected = this.languages.every((lang) => this.post.languagesToTranslate.includes(lang.culture));
      this.selectAll = allLanguagesSelected;
      if (this.selectAllEdit) {
        const allLanguagesSelected = this.post.missingLanguages.every((lang) => this.post.languagesToTranslate.includes(lang));
        this.selectAllEdit = allLanguagesSelected;
      }
    },

    sortPositions() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      const catId = this.$data.cat2 !== "" ? this.$data.cat2 : this.$data.routeCategoryGuid;

      this.$vs.loading();
      api
        .put(`${API.POST_SORT_POSITION}?language=${this.$data.search.language}&cat=${catId}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Sorted Successfully",
              color: "success",
              position: "top-right",
            });
            this.searchData();
          } else {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            text: "Error Deleting",
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    updatePosition(item, type) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      this.$vs.loading();
      api
        .put(`${API.POST_UPDATE_POSITION}/${item._id}?direction=${type}&cat=${item.categoryGuid._id}`, {}, { headers })
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$vs.notify({
              text: "Position Updated Successfully",
              color: "success",
              position: "top-right",
            });
            this.searchData();
          }
        })
        .catch((e) => {
          this.$vs.notify({
            text: e.response.data.error,
            color: "danger",
            position: "top-right",
          });
          this.$vs.loading.close();
        });
    },

    sortBy(field) {
      if (this.sortByField === field) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      } else {
        this.sortByField = field;
        this.sortDirection = "asc";
      }
      this.all = this.sortedData;
    },
    addNewPost() {
      this.fetchActiveCategoriesByLanguage("EN");
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.displayImage = "";
      (this.$data.post = {
        name: "",
        description: "",
        status: true,
        language: "EN",
        position: "",
        image: "",
        categoryObject: {},
        languagesToTranslate: ["EN"],
        count: {
          facebook: 0,
          whatsapp: 0,
          instagram: 0,
        },
        tags: [],
        moveBottom: true,
        moveTop: false,
      }),
        (this.$data.postLanguages = this.$data.languages);
    },
    editingItem(i, data) {
      i.languagesToTranslate = [];
      this.$data.englishData = Object.assign({}, i);
      this.$data.post = Object.assign({}, i);
      this.$data.post.tags.list = i.tags;
      this.$data.postLanguages = this.$data.languages;
      this.$data.postLanguage = i.language;
      this.$data.category = i.categoryObject.name;
      this.fetchActiveCategoriesByLanguage(i.language);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.image;
      this.$data.clone = data == "clone" ? true : false;
    },
    uploadImage(data) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      this.$data.fileName = data.target.files[0].name;
      formdata.append("file", data.target.files[0]);
      formdata.append("post", this.$data.post.name);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            this.$data.displayImage = response.data.files[0].url;
            this.$data.post.image = response.data.files[0].url;
            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deleteImage() {
      this.$data.displayImage = "";
    },
    async btnAddPost() {
      // console.log('db cats', this.$data.category)
      let apiToCall = API.INSERT_POST;
      this.$data.post.language = this.$data.post.language;
      let findCat = this.$data.postCategories.find((x) => x.name === this.$data.category);

      if (findCat == undefined || findCat === null) {
        const cat = this.$data.post.categoryGuid ? this.$data.post.categoryGuid : this.$data.category;
        findCat = this.$data.postCategories.find((x) => x._id === cat);
      }

      this.$data.post.categoryObject = findCat;

      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      let data = this.$data.post;

      if (!data.name || !data.description || !data.language || !data.categoryObject) {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all details.",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      if (this.$data.category === "") {
        this.$vs.notify({
          title: "Error",
          text: "Please select a category.",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      this.$vs.loading();

      try {
        if (!this.$data.isNew && !this.$data.clone) {
          apiToCall = API.UPDATE_POST;

          data["image"] = this.$data.displayImage;

          const res = await api.put(`${apiToCall}/${this.$data.post._id}`, data, { headers });
          if (res.status === 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.post = {
              name: "",
              description: "",
              status: true,
              language: "EN",
              position: "",
              image: "",
              categoryObject: {},
              languagesToTranslate: ["EN"],
              count: {
                facebook: 0,
                whatsapp: 0,
                instagram: 0,
              },
              tags: [],
              moveBottom: true,
              moveTop: false,
            };
            this.searchData();
          }
        } else {
          const res = await api.post(apiToCall, data, { headers });
          if (res.status === 200) {
            this.$vs.notify({
              text: "Saved Successfully",
              color: "success",
              position: "top-right",
            });
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.defaultalert = false;
            this.$data.post = {
              name: "",
              description: "",
              status: true,
              language: "EN",
              position: "",
              image: "",
              categoryObject: {},
              languagesToTranslate: ["EN"],
              count: {
                facebook: 0,
                whatsapp: 0,
                instagram: 0,
              },
              tags: [],
              moveBottom: true,
              moveTop: false,
            };
            this.searchData();
          }
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: res.data.error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async createAndTranslate() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      let data = this.$data.post;
      let findCat = this.$data.postCategories.find((x) => x.name === this.$data.category);

      if (findCat == undefined || findCat === null) {
        findCat = this.$data.postCategories.find((x) => x._id === this.$data.category);
      }

      data.categoryObject = findCat;

      if (!data.name || !data.description || !data.language || !data.categoryObject) {
        this.$vs.notify({
          title: "Error",
          text: "Please fill all details.",
          color: "danger",
          position: "top-right",
        });
        return;
      }
      this.$data.showLoader = true;
      try {
        this.$data.defaultalert = false;
        const res = await api.post(API.C_AND_T_POST, data, { headers });
        if (res.status === 200) {
          this.$vs.notify({
            text: "Post Created and Translated",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          this.$data.post = {
            description: "",
            status: true,
            language: "",
            position: "",
            name: "",
            image: "",
            categoryObject: {},
            count: {
              facebook: 0,
              whatsapp: 0,
              instagram: 0,
            },
            tags: [],
            languagesToTranslate: ["EN"],
          };

          this.searchData();
          this.$data.showLoader = false;
        }
      } catch (error) {
        this.$data.showLoader = false;
        this.$vs.notify({
          title: "Error",
          text: res.data.error,
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },

    async updateAndTranslate() {
      // console.log('data untouched', this.$data.post)
      this.$vs.loading();
      try {
        this.$data.showLoader = true;
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
        }

        let data = this.$data.post;
        let findCat = this.$data.postCategories.find((x) => x.name === this.$data.category);

        if (findCat == undefined || findCat === null) {
          findCat = this.$data.postCategories.find((x) => x._id === this.$data.post.categoryGuid);
          if (findCat == undefined || findCat === null) {
            findCat = this.$data.postCategories.find((x) => x._id === this.$data.post.categoryGuid._id);
          }
        }

        data.categoryObject = findCat;
        data.translate = this.$data.post.translate ? true : false;

        const res = await api.put(`${API.U_AND_T_POST}/${this.$data.post._id}`, data, { headers });
        if (res.status === 200) {
          this.$vs.notify({
            text: "Saved Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.post = {
            description: "",
            status: true,
            language: "",
            position: "",
            name: "",
            image: "",
            categoryObject: {},
            count: {
              facebook: 0,
              whatsapp: 0,
              instagram: 0,
            },
            tags: [],
            languagesToTranslate: ["EN"],
          };

          if (res.data.extraMessages.length > 0) {
            for (const message of res.data.extraMessages) {
              this.$vs.notify({
                text: message + "post not translated",
                color: "warning",
                position: "top-right",
              });
            }
          }

          this.searchData();
          this.$data.showLoader = false;
          this.$data.defaultalert = false;
        }
      } catch (error) {
        this.$data.showLoader = false;
        this.$vs.notify({
          title: "Error",
          text: res.data.error,
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    fetchAllPost() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .get(`${API.GET_POST}?language=${this.$data.search.language}&sort=${this.$data.search.sort}&status=${this.$data.search.status}`, { headers })
        .then((r) => {
          this.$vs.loading.close();

          this.$data.all = r.data;
          if (!r.status === 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error,
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Error in Fetching Data",
            color: "danger",
            position: "top-right",
          });
        });
    },
    deletePost() {
      this.$vs.loading();
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(`${API.DELETE_POST}/${this.$data.itemToDelete._id}`, {}, { headers })
        .then((r) => {
          if (r.data.status) {
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          } else {
            this.$vs.notify({
              text: "Already Deleted",
              color: "danger",
              position: "top-right",
            });
          }
          this.$data.deletePostPopup = false;
          this.$data.all = this.$data.all.filter((x) => x._id !== this.$data.itemToDelete._id);
          this.$vs.loading.close();
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Error in Deleting Data",
            color: "danger",
            position: "top-right",
          });
        });
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },
    async searchData() {
      try {
        this.$vs.loading();
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) {
          headers["x-master-token"] = JSON.parse(localStorage.user).token;
        }

        const page = !isNaN(this.currentPage) && this.currentPage > 0 ? this.currentPage : 1;

        let apiToCall = `?categoryGuid=${this.$data.routeCategoryGuid}&language=${this.$data.search.language}&sort=${this.$data.search.sort}&status=${this.$data.search.status}&tag=${this.$data.routeTagName}&tagLang=${this.$data.routeTagLanguage}&page=${page}&limit=${this.limit}`;

        const res = await api.get(`${API.SEARCH_POST}${apiToCall}`, { headers });
        if (res.status === 200) {
          if (res.data.data[0].language === "EN") {
            for (const post of res.data.data) {
              post.tooltipContent =
                post.missingLanguages.length > 0 ? "Missing Languages: " + post.missingLanguages.join(", ") : "All Languages are translated";
            }
          }

          this.$data.all = res.data.data || [];
          this.$data.cat2 = res.data.data[0].categoryGuid._id || "";
          this.$data.search.language = res.data.data[0].language || "EN";
          this.$data.Name = "under " + res.data.data[0].categoryGuid.name + " Category" || "";

          this.totalPages = Math.ceil(res.data.totalNumber / this.limit);

          if (this.$data.routeTagName === undefined) {
            const newRoute = {
              path: this.$route.path,
              query: {
                category: res.data.data[0].categoryObject._id,
                catLang: res.data.data[0].language,
              },
            };

            if (JSON.stringify(this.$route.query) !== JSON.stringify(newRoute.query)) {
              this.$router.push(newRoute);
            }
          }
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "No Data Found",
          color: "danger",
          position: "top-right",
        });
        this.$data.all = [];
      } finally {
        this.$vs.loading.close();
      }
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "0",
      };
      this.$data.limit = 25;
      this.$data.currentPage = 1;
      this.searchData();

      // not needed
      // if (this.$data.routeTagName !== undefined) {
      //   this.fetchAllPostsByTagName(this.$data.routeTagName, this.$data.routeTagLanguage);
      // } else if (this.$data.routeCategoryGuid !== undefined) {
      //   this.fetchAllPostsByCatgeoryGuid(this.$data.routeCategoryGuid, this.$data.routeCatLanguage);
      // } else {
      //   this.fetchAllPost();
      // }
    },
    fetchAllTags(lang) {
      this.$vs.loading();
      api
        .get(`${API.GET_TAG}?language=${lang}`)
        .then((r) => {
          this.$vs.loading.close();
          this.$data.tags = [];
          r.data.forEach((element) => {
            this.$data.tags.push(element.name);
          });
        })
        .catch(() => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "No Tags Found",
            color: "danger",
            position: "top-right",
          });
        });
    },
    fetchActiveCategoriesByLanguage(lang, next) {
      this.$vs.loading();
      this.$data.postCategories = [];
      api
        .get(`${API.GET_ACTIVE_CATEGORY_BY_LANGUAGE}?language=${lang}`)
        .then((r) => {
          this.$vs.loading.close();
          if (r.status === 200) {
            this.$data.postCategories = r.data.data;
            const prefill = this.$data.postCategories.find((x) => x._id === this.routeCategoryGuid);
            if (prefill) {
              this.$data.category = prefill.name;
              this.$data.post.categoryObject = Object.assign({}, prefill);
            }
            if (next != null) {
              next();
            }
          } else {
            this.$data.category = "";
            this.$vs.notify({
              title: "Error",
              text: "Choose Other Language No Category Found",
              color: "danger",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    viewDescription(i) {
      this.$data.viewDetails = true;
      this.$data.details = i.description;
    },
    fetchAllPostsByCatgeoryGuid(guid, lang) {
      this.$vs.loading();
      api
        .get(`${API.GET_ALL_POST_BY_CAT_GUID}?catId=${guid}&language=${lang}&sort=${this.$data.search.sort}&status=${this.$data.search.status}`, {})
        .then((r) => {
          // console.log(r)
          this.$vs.loading.close();
          if (!r.status === 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error + " for this Category",
              color: "danger",
              position: "top-right",
            });
          } else {
            for (const post of r.data) {
              post.tooltipContent =
                post.missingLanguages.length > 0 ? "Missing Languages: " + post.missingLanguages.join(", ") : "All Languages are translated";
            }

            this.$data.all = r.data;
            this.routeCategoryName = r.data[0].categoryGuid.name;
            this.$data.Name = "under " + this.routeCategoryName + " Category";
          }
        })
        .catch(() => {});
    },
    fetchAllPostsByTagName(tag, lang) {
      this.$vs.loading();
      api
        .get(`${API.GET_ALL_POST_BY_TAG_NAME}?tagName=${tag}&language=${lang}&sort=${this.$data.search.sort}`, {})
        .then((r) => {
          // console.log(r)
          this.$vs.loading.close();
          if (!r.status === 200) {
            this.$vs.notify({
              title: "Error",
              text: r.data.error + " for this Tag",
              color: "danger",
              position: "top-right",
            });
          } else {
            this.$data.all = r.data;
            this.$data.Name = "Under " + tag + " Tag";
          }
        })
        .catch(() => {});
    },
    async fileterusingLanguage(event, item) {
      try {
        if (event) {
          let headers = {
            "Content-Type": "application/json;charset=utf-8",
          };
          const user = JSON.parse(localStorage.getItem("user"));
          if (user && user.token) {
            headers["token"] = user.token;
          }
          if (!this.isNew) {
            let id = item.ref || item._id;
            this.$vs.loading();

            const res = await api.get(`${API.GET_SINGLE_POST}/${id}?language=${event}`, { headers });
            this.$data.post = Object.assign({}, res.data);
            this.$data.category = res.data.categoryObject.name;
            this.$data.displayImage = res.data.image;
            this.$data.post.language = event;
            const missingLanguages = this.$data.all.find((x) => x._id === id).missingLanguages;
            this.$data.post.missingLanguages = missingLanguages;
            this.$data.post.languagesToTranslate = [];

            this.fetchActiveCategoriesByLanguage(event);
            this.fetchAllTags(event);
            this.$vs.loading.close();
            // not needed
            // if (this.routeCategoryGuid !== undefined || this.routeCatLanguage !== undefined) {
            //   this.fetchAllPostsByCatgeoryGuid(this.routeCategoryGuid, this.routeCatLanguage);
            // } else if (this.routeTagName !== undefined) {
            //   this.fetchAllPostsByTagName(this.routeTagName, this.routeTagLanguage);
            // } else {
            //   this.fetchAllPost();
            // }
            this.$vs.loading.close();
          }
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          title: "Error",
          text: "Translation Not Found or Localised Category Not Exist",
          color: "danger",
          position: "top-right",
        });
        this.$data.post = Object.assign({}, this.$data.englishData);
      }
    },
  },
  mounted() {
    this.fetchAllLanguages();
    this.$data.routeCategoryGuid = this.$route.query.category;
    this.$data.routeCatLanguage = this.$route.query.catLang;
    this.$data.routeTagLanguage = this.$route.query.tagLang;
    this.$data.routeCategoryName = this.$route.query.catName;
    this.$data.routeTagName = this.$route.query.tagName;

    if (this.$data.routeCategoryGuid !== undefined && this.$data.routeCatLanguage !== undefined) {
      this.$data.search.language = this.$data.routeCatLanguage;
    }

    this.searchData();
    this.fetchAllTags("EN");

    // not needed
    // if (this.routeTagName != undefined) {
    //   if (this.routeTagLanguage == undefined || this.routeTagLanguage == undefined) {
    //     this.$router.push("/post");
    //   }
    //   this.$data.Name = "Under " + this.routeTagName + " Tag";
    //   this.fetchAllTags(this.routeTagLanguage);
    //   this.fetchAllPostsByTagName(this.routeTagName, this.routeTagLanguage);
    //   this.fetchActiveCategoriesByLanguage(this.routeTagLanguage);
    //   this.$data.search.language = this.routeTagLanguage;
    // }

    // if (
    //   this.routeCategoryGuid == undefined &&
    //   this.routeCatLanguage == undefined &&
    //   this.routeCategoryName == undefined &&
    //   this.routeTagLanguage == undefined &&
    //   this.routeTagName == undefined
    // ) {
    //   this.fetchAllTags("EN");
    //   this.fetchAllPost();
    // }
    // if (this.routeCategoryGuid !== undefined || this.routeCatLanguage !== undefined) {
    //   this.fetchAllPostsByCatgeoryGuid(this.routeCategoryGuid, this.routeCatLanguage);
    //   this.fetchAllTags(this.routeCatLanguage);
    //   this.$data.search.language = this.routeCatLanguage;
    // }
  },
};
</script>
<style scoped>
.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 15px;
}

.mb10 {
  margin-bottom: 10px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
  text-align: center;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.eye {
  cursor: pointer;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.closeBtn {
  float: right;
  right: 0px;
  top: 0px;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
